import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { IconButton as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Search } from '../../images/icons/lente.svg';

interface IProps extends StyledComponentProps {
    onClick: () => any;
    disabled?: boolean;
}

const SearchButton = (props: IProps) => {
    return (<MuiButton
        disabled={props.disabled}
        className={props.classes.iconButtonRootSvg}
        onClick={props.onClick}>
            <Search className={props.classes.iconButtonSvg}/>
    </MuiButton>)
}


export default withStyles(styles)(SearchButton)